import { useState } from 'react';
import {
  getUnsupportedBannerDetails,
  shouldShowBannerDetails,
} from 'services/forceUpdate/helpers';
import { SystemBannerProps } from 'shared/components/vxl/SystemBanner/SystemBanner.types';

const makeUnsupportedBannerProps = (
  bannerInfo: SystemBannerProps,
  showCloseButton: boolean,
  onDismiss: () => void,
): SystemBannerProps => {
  return {
    ...bannerInfo,
    onDismiss: showCloseButton ? onDismiss : undefined,
  };
};

export const useUnsupportedBanner = () => {
  const [showUnsupportedBanner, setShowUnsupportedBanner] = useState(
    shouldShowBannerDetails(),
  );

  const unSupportedBanner = getUnsupportedBannerDetails() as SystemBannerProps;
  const { allowClosing } = getUnsupportedBannerDetails();
  const unsupportedBannerProps = makeUnsupportedBannerProps(
    unSupportedBanner,
    allowClosing,
    () => setShowUnsupportedBanner(false),
  );

  return showUnsupportedBanner ? unsupportedBannerProps : null;
};
